module.exports = __webpack_public_path__ + "static/img/portal.b3cf7fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grid/portal.png
// module id = ugNM
// module chunks = 3